export default __webpack_public_path__ + "static/media/support-close.4b5b8a9a.svg";